import React from 'react';
import insentLogo from 'assets/img/brand/logo.png';
import styled from 'styled-components';
import { TEAMS_SUCCESS_PAGE } from 'common/strings';

const MessageBodyContainer = styled.div`
  box-shadow: ${p => p.theme.boxShadow.cardLightShadow};
  width: 400px;
  height: 250px;
  margin-top: 24px;
  padding: 20px;
  border-radius: 5px;
`;

const MessageContainer = styled.div`
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
`;

const Logo = styled.img`
  width: 40px;
  height: 42px;
`;

const Page = styled.div`
  height: 100vh;
  background: white;
`;

export default () => {
  const { HEADING, BODY, KNOW_MORE } = TEAMS_SUCCESS_PAGE;
  return (
    <Page>
      <MessageContainer>
        <div className="d-flex justify-content-center mr-2">
          <Logo src={insentLogo} alt="insent logo" />
          <h1 className="ml-1">Insent</h1>
        </div>
        <MessageBodyContainer className="text-center mt-4">
          <div className="mt-3">{HEADING}</div>
          <hr className="w-50" />
          <div>{BODY}</div>
          <div>
            {KNOW_MORE}
            <a
              href={
                'https://help.insent.ai/article/38-integrating-insent-with-your-microsoft-teams'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              here.
            </a>
          </div>
        </MessageBodyContainer>
      </MessageContainer>
    </Page>
  );
};
